// import { useState } from "react";
// import { ChevronDownIcon } from "@heroicons/react/24/solid";

// const options = [
//   { label: "جميع الحسابات", value: "" },
//   { label: "مستخدم", value: "مستخدم" },
//   { label: "وكيل", value: "وكيل" },
//   { label: "منصب", value: "منصب" },
//   { label: "طلب وكيل بانتظار الموافقة", value: "طلب وكيل بانتظار الموافقة" },
//   { label: "طلب منصب بانتظار الموافقة", value: "طلب منصب بانتظار الموافقة" },
// ];

// interface AccountTypeSelectProps {
//   value: string;
//   onChange: (val: string) => void;
//   id?: string;
// }

// export default function AccountTypeSelect({
//   value,
//   onChange,
//   id,
// }: AccountTypeSelectProps) {
//   const [open, setOpen] = useState(false);
//   const selected = options.find((o) => o.value === value);
//   const [pendingAccountType, setPendingAccountType] = useState<string | null>(
//     null
//   );
//   const [pendingUserId, setPendingUserId] = useState<string | null>(null);
//   const [confirmModalOpen, setConfirmModalOpen] = useState(false);

//   return (
//     <div className="relative w-64 font-tajawal">
//       <button
//         type="button"
//         style={{ fontFamily: "Tajawal, sans-serif" }}
//         onClick={() => setOpen(!open)}
//         className="w-full bg-[#262d34] text-white px-4 py-2 rounded-lg shadow focus:outline-none flex justify-between items-center"
//       >
//         <span>{selected ? selected.label : "اختر نوع الحساب"}</span>
//         <ChevronDownIcon className="h-5 w-5 text-gray-300" />
//       </button>

//       {open && (
//         <ul className="absolute z-50 mt-2 w-full bg-[#1f2937] border border-gray-600 rounded-lg shadow-lg">
//           {options.map((option) => (
//             <li
//               key={option.value}
//               onClick={() => {
//                 onChange(option.value);
//                 setOpen(false);
//               }}
//               style={{ fontFamily: "Tajawal, sans-serif" }}
//               className={`px-4 py-2 text-white  hover:bg-[#374151] cursor-pointer ${
//                 value === option.value ? "bg-[#374151]" : ""
//               }`}
//             >
//               {option.label}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }


import { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export type AccountTypeOption = {
  label: string;
  value: string;
};

const options: AccountTypeOption[] = [
  {
    label: "جميع الحسابات",
    value: "",
  },
  {
    label: "مستخدم",
    value: "مستخدم",
  },
  {
    label: "وكيل",
    value: "وكيل",
  },
  {
    label: "منصب",
    value: "منصب",
  },
  {
    label: "طلب وكيل بانتظار الموافقة",
    value: "طلب وكيل بانتظار الموافقة",
  },
  {
    label: "طلب منصب بانتظار الموافقة",
    value: "طلب منصب بانتظار الموافقة",
  },
];

interface AccountTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  disabled?: boolean;
  includeAllOption?: boolean;
}

export default function AccountTypeSelect({
  value,
  onChange,
  id,
  disabled = false,
  includeAllOption = true,
}: AccountTypeSelectProps) {
  const [open, setOpen] = useState(false);

  const containerRef =
    useRef<HTMLDivElement | null>(null);

  const visibleOptions =
    includeAllOption
      ? options
      : options.filter(
          (option) => option.value !== "",
        );

  const selected =
    visibleOptions.find(
      (option) => option.value === value,
    );

  useEffect(() => {
    const handleOutsideClick = (
      event: MouseEvent,
    ) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(
          event.target as Node,
        )
      ) {
        setOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick,
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick,
      );
    };
  }, []);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  return (
    <div
      ref={containerRef}
      className="relative w-64 font-tajawal"
    >
      <button
        id={id}
        type="button"
        disabled={disabled}
        style={{
          fontFamily:
            "Tajawal, sans-serif",
        }}
        onClick={() =>
          setOpen((previous) => !previous)
        }
        className={`w-full bg-[#262d34] text-white px-4 py-2 rounded-lg shadow focus:outline-none flex justify-between items-center ${
          disabled
            ? "opacity-60 cursor-not-allowed"
            : "cursor-pointer"
        }`}
      >
        <span>
          {selected
            ? selected.label
            : "اختر نوع الحساب"}
        </span>

        <ChevronDownIcon
          className={`h-5 w-5 text-gray-300 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && !disabled && (
        <ul className="absolute z-50 mt-2 w-full bg-[#1f2937] border border-gray-600 rounded-lg shadow-lg overflow-hidden">
          {visibleOptions.map(
            (option) => (
              <li
                key={
                  option.value ||
                  "__all_accounts__"
                }
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                style={{
                  fontFamily:
                    "Tajawal, sans-serif",
                }}
                className={`px-4 py-2 text-white hover:bg-[#374151] cursor-pointer ${
                  value === option.value
                    ? "bg-[#374151]"
                    : ""
                }`}
              >
                {option.label}
              </li>
            ),
          )}
        </ul>
      )}
    </div>
  );
}